import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges,
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { AnchoredPanelController } from '@shared/utils/anchored-panel.controller';

@Component({
  selector: 'app-prompt-hints-dropdown',
  templateUrl: './prompt-hints-dropdown.component.html',
  styleUrls: ['./prompt-hints-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  host: {
    '[class.visible]': 'panel.isVisible()',
    '[style.display]': 'panel.display()',
    '[style.position]': '"fixed"',
    '[style.z-index]': '"1000"',
    '[style.top]': 'panel.top()',
    '[style.bottom]': 'panel.bottom()',
    '[style.left]': 'panel.left()',
    '[style.width]': 'panel.width()',
    '[style.max-width]': '"800px"',
    '[style.--anchored-panel-max-height]': 'panel.maxHeight()',
  },
  imports: [MatIcon],
})
export class PromptHintsDropdownComponent implements OnChanges, OnDestroy {
  @Input() promptHints: string[] = [];
  @Input() isVisible = false;
  @Input() selectedIndex = -1;
  @Input() anchor: HTMLElement | null = null;

  @Output() hintSelected = new EventEmitter<string>();
  @Output() selectedIndexChange = new EventEmitter<number>();

  protected readonly panel = new AnchoredPanelController({
    placement: 'below',
    gapPx: 4,
    maxHeightPx: 300,
    minHeightPx: 120,
  });

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isVisible'] || changes['anchor'] || changes['promptHints']) {
      this.panel.update(this.isVisible, this.anchor);
    }
  }

  ngOnDestroy(): void {
    this.panel.destroy();
  }

  protected selectHint(hint: string): void {
    this.hintSelected.emit(hint);
  }

  protected onHintHover(index: number): void {
    this.selectedIndexChange.emit(index);
  }
}
